export class GiftedVoucherAuditEntry {
    constructor(
        public id: string,
        public changes: { [ key: string ]: any },
        public giftedVoucherId: string,
        public userId: string | null,
        public dateTime: Date
    ) { }
}
